import React from 'react'
import { assets } from '../../../../../utils/assetsSrc'
import { useLocation, useNavigate } from 'react-router-dom'
import { allRoutes } from '../../../../../utils/routeConstants'
import './risk-assessment-nested-tabs.scss'

export default function RiskAssessmentNestedTabs() {
    const location = useLocation()
    const nav = useNavigate()
    const tabsList = [
        {
            icon:'',
            label:'Summary',
            link: allRoutes.dashboardRoutes.assessmentRoutes.summary,
            type: [1, 2, 3]
        },
        {
            icon:'',
            label:'Attendance record',
            link: allRoutes.dashboardRoutes.assessmentRoutes.attendanceRecord,
            type: [1, 2, 3]
        },
        {
            icon:'',
            label:'Assessment info',
            link: allRoutes.dashboardRoutes.assessmentRoutes.riskAssessmentInfo,
            type: [1, 2, 3]
        },
        {
            icon:'',
            label:'History',
            link: allRoutes.dashboardRoutes.assessmentRoutes.revisionHistory,
            type: [1, 2, 3]
        },
        {
            icon:'',
            label:'Limits of machine',
            link: allRoutes.dashboardRoutes.assessmentRoutes.limitsOfMachine,
            type: [1]
        },
        {
            icon:'',
            label:'Assumptions',
            link: allRoutes.dashboardRoutes.assessmentRoutes.assumptions,
            type: [1]
        }
    ]
    return (
        <div className='ra-nested-tabs-wrapper'>
            {tabsList.map(tab=>
                tab.type.includes(location.state?.type) && (
                    <span  key ={tab.label} className='nested-tab' onClick={()=>nav(tab.link,{state:{...location.state}})}>
                        <img src={assets.clipboard}/>
                        {tab.label}
                    </span>
                )
            )}
        </div>
    )
}
